import axios from "axios";
import { defaultConfig } from "../config";
import { ErrorMessage, removeAuth } from "../components/common/Helper";


const axiosInt = axios.create({
  baseURL: defaultConfig.baseAPIUrl,
});

axiosInt.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      removeAuth();
      window.location.href = `/`;
    }

 if (error?.response?.status === 406) {
      ErrorMessage(error?.response?.data?.message);
   setTimeout(() => {
    window.location.href = "/subscription";
  }, 1000); // delay in milliseconds
    }

    if (error?.response?.status === 403) {
      window.location.href = "/";
    } 
  }
);

export default axiosInt;
